import React from 'react';
import PropTypes from 'prop-types';
import { Button, ButtonGroup } from '@one-thd/sui-atomic-components';
import { ArrowBack } from '@one-thd/sui-icons';

export const SurveyIframeOverlay = ({ surveyUrl, onClose }) => (
  <div
    className="sui-absolute sui-inset-0 sui-z-800 sui-bg-primary sui-flex sui-flex-col"
    data-component="SurveyIframeOverlay"
  >
    <div className="sui-shrink-0">
      <Button variant="ghost" startIcon={ArrowBack} onClick={onClose}>Back to chat</Button>
    </div>
    {/* `min-h-0` lets the iframe shrink in the flex column; `w-full` overrides its
        300px default intrinsic width, which would otherwise squeeze the survey. */}
    <iframe
      src={surveyUrl}
      title="Post-chat survey"
      sandbox="allow-scripts allow-forms allow-same-origin"
      className="sui-flex-1 sui-min-h-0 sui-w-full sui-border-none"
    />
  </div>
);

SurveyIframeOverlay.propTypes = {
  surveyUrl: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
};
